/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationIPWhitelistResponseData
 */
export interface CreateOrganizationIPWhitelistResponseData {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationIPWhitelistResponseData
     */
    organization_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationIPWhitelistResponseData
     */
    ip_address?: string;
}

/**
 * Check if a given object implements the CreateOrganizationIPWhitelistResponseData interface.
 */
export function instanceOfCreateOrganizationIPWhitelistResponseData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateOrganizationIPWhitelistResponseDataFromJSON(json: any): CreateOrganizationIPWhitelistResponseData {
    return CreateOrganizationIPWhitelistResponseDataFromJSONTyped(json, false);
}

export function CreateOrganizationIPWhitelistResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationIPWhitelistResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organization_id': !exists(json, 'organization_id') ? undefined : json['organization_id'],
        'ip_address': !exists(json, 'ip_address') ? undefined : json['ip_address'],
    };
}

export function CreateOrganizationIPWhitelistResponseDataToJSON(value?: CreateOrganizationIPWhitelistResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization_id': value.organization_id,
        'ip_address': value.ip_address,
    };
}

